const rawPublicUrl = process.env.PUBLIC_URL;

export const BASENAME =
  rawPublicUrl && rawPublicUrl !== '.'
    ? rawPublicUrl
    : '/';

const ASSET_PREFIX =
  rawPublicUrl && rawPublicUrl !== '.'
    ? rawPublicUrl
    : '';

export const getAssetPath = (path = '') => {
  if (!path) {
    return ASSET_PREFIX || '/';
  }

  if (ASSET_PREFIX && path.startsWith('/')) {
    return `${ASSET_PREFIX}${path}`;
  }

  if (!path.startsWith('/')) {
    return `${ASSET_PREFIX}/${path}`;
  }

  return path;
};

export const getBasename = () => BASENAME;

